module.exports = __webpack_public_path__ + "img/20200429154938TIM截图20200429153908.3864845b.png";